import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const PdpChatV2Page = withCompass(
  () => import("@faire/prototype-playground/workspace/qh/pdp-chat-v-2")
);

const CompassAIChatPDPInlinePage = withCompass(
  () => import("../../pages/CompassAIChatPDPInlinePage")
);

export function QuentinHsuRoutes() {
  return (
    <Switch>
      <Route
        path="/qh/compass-ai-chat-pdp-inline"
        component={CompassAIChatPDPInlinePage}
      />
      <Route path="/qh/pdp-chat-v-2" component={PdpChatV2Page} />
    </Switch>
  );
}

export const slug = "qh";
